<template>
  <div
    v-loading="loading"
    class="attribute-label"
  >
    <div
      class="fill-line"
    ></div>
    <div class="left-label">
      <tab-info txt="属性标签" />
      <mk-button-biz
        class="button-new-tag"
        width="80px"
        height="22px"
        font-size="12px"
        icon="el-icon-plus"
        @click="drawerVisible = true"
      >
        管理标签
      </mk-button-biz>
      <div class="tag-value">
        <mk-tag
          v-for="(tag, tagIndex) in attributeTags"
          :key="tagIndex"
          :disable-transitions="false"
        >
          {{ tag.name }}
        </mk-tag>
      </div>
    </div>
    <div class="right-label">
      <tab-info txt="行为标签" />
      <div class="behavior-tag">
        <template v-if="actionTags.length > 0">
          <div
            v-for="(tag, tagIndex) in actionTags"
            :key="tagIndex"
            class="behavior-tag-item"
            :class="{'active': tag.isSwithOn}"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="点击将此行为转为属性标签"
              placement="top"
              :popper-class="tag.isSwithOn ? 'behavior-tag-item-tooltip active' : 'behavior-tag-item-tooltip'"
            >
              <mk-tag
                :disable-transitions="false"
                @click.native="addActionToAttribute(!tag.isSwithOn, tag.id, tag.enable,tagIndex)"
              >
                {{ tag.name }}({{ tag.attachScore }})
                <ds-iconfont
                  class="exchange-icon"
                  icon-class="iconzhuanhuan"
                />
              </mk-tag>
            </el-tooltip>
            <!-- <mk-popover
              placement="top"
              trigger="hover"
              :popper-class="tag.isSwithOn ? 'behavior-tag-item-popper active' : 'behavior-tag-item-popper'"
            >
              <mk-tag
                slot="reference"
                :disable-transitions="false"
                @click.native="addActionToAttribute(!tag.isSwithOn, tag.id, tag.enable,tagIndex)"
              >
                {{ tag.name }}({{ tag.attachScore }})
                <ds-iconfont
                  class="exchange-icon"
                  icon-class="iconzhuanhuan"
                />
              </mk-tag>
              <div>
                点击将此行为转为属性标签
              </div>
            </mk-popover> -->
            <!-- <mk-popover
              v-if="!tag.isSwithOn"
              placement="right-start"
              trigger="hover"
            >
              <mk-switch
                slot="reference"
                v-model="tag.isSwithOn"
                disabled
                @click.native="addActionToAttribute(!tag.isSwithOn, tag.id, tag.enable)"
              >
              </mk-switch>
              <div>
                点击将此行为转为属性标签
              </div>
            </mk-popover>
            <mk-switch
              v-else
              v-model="tag.isSwithOn"
              disabled
              @click.native="addActionToAttribute(!tag.isSwithOn, tag.id, tag.enable)"
            >
            </mk-switch> -->
          </div>
        </template>
        <no-data
          v-else
          place-holder="暂无标签"
        />
      </div>
    </div>
    <mk-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      :show-close="false"
      size="40%"
      class="manage-tags"
      :hide-header="true"
      :append-to-body="true"
      :modal-append-to-body="false"
      @close="onClose"
    >
      <div class="main-content">
        <div class="manage-tags-title">
          <span class="fw500">管理标签</span>
          <i
            class="el-icon-close close cursor"
            @click="drawerVisible = false"
          />
        </div>
        <div
          v-loading="drawerLoading"
          class="wrapper"
        >
          <tab-info txt="属性标签" />
          <div class="used-tags">
            <mk-tag
              v-for="(tag, tagIndex) in editDynamicTags"
              :key="tagIndex"
              closable
              :disable-transitions="true"
              class="drawer-attr-tag"
              @close="handleClose(tag)"
            >
              {{ tag.name }}
            </mk-tag>
            <mk-input
              v-if="inputVisible"
              ref="saveTagInput"
              v-model="inputValue"
              class="input-new-tag"
              width="80"
              height="22"
              maxlength="8"
              placeholder="请输入"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </mk-input>
            <mk-button-biz
              v-else
              class="button-new-tag"
              width="90px"
              height="22px"
              font-size="12px"
              icon="el-icon-plus"
              @click="showInput"
            >
              自定义标签
            </mk-button-biz>
          </div>
          <div class="other-tags-wrapper has-child">
            <!-- 自定义标签数组 -->
            <tab-info txt="我的标签" />
            <div
              v-if="myTagData && myTagData.length > 0"
              class="tag-library-item"
            >
              <mk-tag
                v-for="(tag, index) in myTagData"
                :key="index"
                :disable-transitions="false"
                class="no-select"
                :class="{'tag-disabled': tag.isUserSelect, 'cursor': !tag.isUserSelect}"
                @click="tagChoose(tag.isUserSelect, tag.id, true)"
              >
                <i class="el-icon-plus el-icon--left"></i>{{ tag.name }}
              </mk-tag>
            </div>
            <no-data v-else />
          </div>
          <div
            v-for="item in comTagData"
            :key="item.id"
            class="other-tags-wrapper"
            :class="{'has-child': item.children.length > 0}"
          >
            <template v-if="item.children.length > 0">
              <!-- <div class="second-title">
                {{ item.name }}
              </div> -->
              <tab-info :txt="item.name" />
              <div class="tag-library-item">
                <mk-tag
                  v-for="(tag, tagIndex) in item.children"
                  :key="tagIndex"
                  :disable-transitions="false"
                  class="no-select"
                  :class="{'tag-disabled': tag.isUserSelect, 'cursor': !tag.isUserSelect}"
                  @click="tagChoose(tag.isUserSelect, tag.id, false)"
                >
                  <i class="el-icon-plus el-icon--left"></i>{{ tag.name }}
                  <span v-if="tag.selfActionCount">
                    ({{ tag.selfActionCount }})
                  </span>
                </mk-tag>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        class="drawer-bottom"
      >
        <mk-button-biz
          width="64px"
          size="small"
          @click="drawerVisible = false"
        >
          取 消
        </mk-button-biz>
        <mk-button-biz
          width="64px"
          type="primary"
          size="small"
          @click="saveTag"
        >
          保 存
        </mk-button-biz>
      </div>
    </mk-drawer>
  </div>
</template>

<script>
import TabInfo from '@components/tab-info'
import NoData from '@components/no-data'
export default {
  name: 'AttributeLabel',
  components: {
    TabInfo,
    NoData
  },
  props: {
    // 线索id
    clueId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 智能标签
      intelligenceTags: ['标签一', '标签二', '标签三'],
      // 属性标签
      attributeTags: [],
      // 行为标签
      actionTags: [],
      // 编辑的标签
      editDynamicTags: [],
      // 属性标签输入框是否可见
      value: '',
      // 是否显示提示
      showMention: false,
      // 抽屉是否可见
      drawerVisible: false,
      // 标签输入框是否可见
      inputVisible: '',
      // 标签输入框的的值
      inputValue: '',
      // 企业的标签
      comTagData: [],
      // 我的标签
      myTagData: [],
      // 是否正在加载
      loading: false,
      // 管理标签drawer是否正在加载
      drawerLoading: false
    }
  },
  mounted () {
    this.wxcontactTagGet()
  },
  methods: {
    // 关闭管理标签弹窗时
    onClose () {
      this.wxcontactTagGet()
    },
    // 点击关闭标签
    handleClose (tag) {
      this.tagDelete(tag)
      this.editDynamicTags.splice(this.editDynamicTags.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$children[0].$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.editDynamicTags.push({
          name: inputValue
        })
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 保存标签
    saveTag () {
      let associateTagArr = []
      let createTagArr = []
      this.editDynamicTags.forEach(item => {
        if (item.id) {
          associateTagArr.push(item.id)
        } else {
          createTagArr.push({ name: item.name })
        }
      })
      let params = {
        associateTagArr,
        createTagArr,
        contactID: this.clueId
      }
      this.wxcontactAttributeTagPut(params)
    },
    // 更新属性标签接口
    async wxcontactAttributeTagPut (params) {
      this.drawerLoading = true
      let res = await BIZAPIS.TagApi.wxcontactAttributeTagPut(params)
      this.drawerLoading = false
      if (res.success) {
        this.drawerVisible = false
        this.wxcontactTagGet()
        this.$message.success('标签已更新')
      } else {
        this.$message.success('标签更新失败')
      }
    },
    // 点击开关
    addActionToAttribute (offOrOn, id, enable, index) {
      if (offOrOn && !enable) {
        return this.$message.error('添加失败；该标签已停用')
      }
      let arr = this.attributeTags.map(item => item.id)
      // 开启
      if (offOrOn) {
        arr.push(id)
      } else {
        arr.splice(arr.indexOf(id), 1)
      }
      let params = {
        clueID: this.clueId,
        idArr: arr
      }
      this.wxcontactTagPut(params, offOrOn, index)
    },
    // 行为标签添加到属性标签接口
    async wxcontactTagPut (params, isAdd, index) {
      let msg
      if (isAdd) {
        msg = '添加属性标签成功'
      } else {
        msg = '属性标签已移除'
      }
      // this.loading = true
      let res = await BIZAPIS.TagApi.wxcontactTagPut(params)
      // this.loading = false
      if (res.success) {
        // 顺序错乱，手动操作属性标签数组及行为标签数组
        // this.wxcontactTagGet()
        if (isAdd) {
          this.attributeTags.push({
            ...this.actionTags[index],
            isSwithOn: true
          })
        } else {
          let i = 0
          let len = this.attributeTags.length
          for (i; i < len; i++) {
            if (this.attributeTags[i].id === this.actionTags[index].id) {
              this.attributeTags.splice(i, 1)
              break
            }
          }
        }
        this.actionTags[index].isSwithOn = isAdd
        this.$message.success(msg)
      } else {
        this.$message.error('标签更新失败')
      }
    },
    // 删除标签
    tagDelete (tag) {
      // 是否是自定义标签
      if (tag.type === 'user') {
        this.myTagData.forEach(item => {
          if (item.id === tag.id) {
            item.isUserSelect = false
          }
        })
      } else {
        this.comTagData.forEach(item => {
          if (item.children.length > 0) {
            item.children.forEach(innerItem => {
              if (innerItem.id === tag.id) {
                innerItem.isUserSelect = false
              }
            })
          }
        })
      }
    },
    // 点击添加标签
    tagChoose (isAdded, id, isMyTag) {
      if (isAdded) {
        return
      }
      if (isMyTag) {
        this.myTagData.forEach(item => {
          if (item.id === id) {
            item.isUserSelect = true
            this.editDynamicTags.push(item)
          }
        })
      } else {
        this.comTagData.forEach(item => {
          // // 判断是否是单选，若为单选并且已经选择则，不能添加
          // let flag = false
          // if (item.childrenExclusive) {
          //   item.children.forEach(innerItem => {
          //     if (innerItem.isUserSelect) {
          //       flag = true
          //     }
          //   })
          // }
          // if (flag) {
          //   return false
          // }

          if (item.children.length > 0) {
            item.children.forEach(innerItem => {
              if (innerItem.id === id) {
                innerItem.isUserSelect = true
                this.editDynamicTags.push(innerItem)
              }
            })
          }
        })
      }
    },
    // 加载所有标签
    async getAllOtherTags () {
      this.loading = true
      let res = await Promise.all([this.tagEnableGet(), this.tagUserGet()])
      // 企业标签
      if (res[0].success) {
        res[0].data = res[0].data ? res[0].data : []
        let newData = this._.cloneDeep(res[0].data)
        let attributeArr = this.attributeTags.map(item => item.id)
        let actionArr = this.actionTags.map(item => item.id)
        // 前端判断标签是否已选择
        newData.forEach(item => {
          if (item.children.length > 0) {
            // 没有被禁用的标签
            item.children.forEach(innerItem => {
              if (attributeArr.indexOf(innerItem.id) !== -1) {
                innerItem.isUserSelect = true
              } else {
                innerItem.isUserSelect = false
              }
              // 关联当条线索已关联的行为标签与企业标签
              let index = actionArr.indexOf(innerItem.id)
              if (index !== -1) {
                innerItem.selfActionCount = this.actionTags[index].attachScore
              } else {
                innerItem.selfActionCount = ''
              }
            })
          }
        })
        this.comTagData = newData
      }
      if (res[1].success) {
        let data = res[1].data ? res[1].data : []
        let arr = this.attributeTags.map(item => item.id)
        // 前端判断标签是否已选择
        data.forEach(item => {
          if (arr.indexOf(item.id) !== -1) {
            item.isUserSelect = true
          } else {
            item.isUserSelect = false
          }
        })
        this.myTagData = data
      }
      this.loading = false
    },
    // 查询企业标签
    async tagEnableGet () {
      let res = await BIZAPIS.TagApi.tagEnableGet()
      return res
    },
    // 查询我的标签
    async tagUserGet () {
      let res = await BIZAPIS.TagApi.tagUserGet()
      return res
    },
    // 获得线索相关标签，属性标签、行为标签
    async wxcontactTagGet () {
      let params = {
        clueID: this.clueId
      }
      this.loading = true
      let res = await BIZAPIS.TagApi.wxcontactTagGet(params)
      this.loading = false
      if (res.success) {
        res.data.actionTagArr = res.data.actionTagArr
          ? res.data.actionTagArr
          : []
        this.attributeTags = res.data.attributeTagArr
          ? res.data.attributeTagArr
          : []
        this.editDynamicTags = this._.cloneDeep(this.attributeTags)
        // 判断行为标签是否加入了左侧属性标签。初始化开关值
        let arr = this.attributeTags.map(item => item.id)
        res.data.actionTagArr.forEach(item => {
          if (arr.indexOf(item.id) !== -1) {
            item.isSwithOn = true
          } else {
            item.isSwithOn = false
          }
        })
        this.actionTags = res.data.actionTagArr
        this.getAllOtherTags()
      }
    }
  }
}
</script>
<style lang="scss">
  .behavior-tag-item-tooltip {
    background: rgba(0, 0, 0, 0.75);
  }

  .behavior-tag-item-tooltip.active {
    display: none !important;
  }
</style>
<style lang="scss" scoped>
.manage-tags {
  /deep/ .button-new-tag {
    border-radius: 2px;
    border-color: #ccecff;
    margin-top: 8px;

    span {
      margin-left: 0;
      color: #009cff;
    }

    .el-icon-plus {
      color: #009cff;
    }
  }

  /deep/ .el-drawer__body {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .main-content {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .wrapper {
    padding: 20px;
    flex: 1;
    overflow-y: scroll;
  }

  .manage-tags-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #262626;
    font-size: 16px;
    height: 60px;
    padding: 0 20px;
    background-color: #fbfcfd;
    box-shadow: 0 1px 0 0 #e8e8e8;
    border-radius: 2px 2px 0 0;
    flex-shrink: 0;

    .close {
      font-size: 20px;
      color: #bfbfbf;
      cursor: pointer;
    }
  }

  .first-title {
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;

    .decoration-line {
      display: inline-block;
      width: 3px;
      height: 13px;
      border-radius: 1px;
      background-color: #009cff;
      margin-right: 5px;
      position: relative;
      top: 1px;
    }
  }

  .second-title {
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
  }

  .used-tags {
    margin-top: 7px;
    padding-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    user-select: none;

    .el-tag {
      margin: 8px 8px 0 0;
      border-radius: 2px;
      padding: 0 8px;
      color: #4e78f0;
      background: #e6efff;
      border: none;

      .el-icon-close {
        color: #4e78f0;
      }
    }

    .input-new-tag {
      margin: 8px 8px 0;
    }
  }

  .other-tags-wrapper {
    padding: 0;
    border: none;
  }

  .other-tags-wrapper.has-child {
    padding: 20px 0;
    border-top: 1px dashed #d9d9d9;
  }

  .tag-library {
    margin-top: 20px;
  }

  .tag-library-item {
    margin-top: 7px;

    .el-tag {
      margin: 8px 8px 0 0;
      border-radius: 2px;
      padding: 0 8px;
      color: #595959;
      background: rgba(243, 243, 243, 1);
      border: 1px solid rgba(217, 217, 217, 1);

      .el-icon-plus {
        color: #888;
      }
    }

    .tag-disabled {
      border: 1px solid #e8e8e8;
      color: #c4c4c4;

      .el-icon-plus {
        color: #c4c4c4;
      }
    }
  }
}

.attribute-label {
  display: flex;
  margin: 20px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  min-height: calc(100% - 40px);

  .fill-line {
    position: absolute;
    width: 1px;
    height: calc(100% + 40px);
    background: #f0f0f0;
    left: calc(50% - 6px);
    top: -20px;
  }

  /deep/ .button-new-tag {
    border-radius: 2px;
    border-color: #ccecff;
    margin-top: 12px;

    span {
      margin-left: 0;
      color: #009cff;
    }

    .el-icon-plus {
      color: #009cff;
    }
  }

  .left-label {
    min-width: 320px;
    margin-right: 10px;
    flex: 1;
  }

  .tag-title {
    display: flex;
    justify-content: space-between;
    font-size: 13px;

    .tag-title-value {
      &::before {
        position: relative;
        content: '';
        top: 1px;
        margin-right: 5px;
        width: 3px;
        height: 13px;
        display: inline-block;
        background: rgba(0, 156, 255, 1);
        border-radius: 1px;
      }
    }

    .tag-title-mention {
      color: #bfbfbf;
      font-weight: normal !important;
    }
  }

  .tag-value {
    display: flex;
    flex-wrap: wrap;
    margin-top: -3px;

    & /deep/ .el-tag {
      margin: 12px 8px 0 0;
      border-radius: 2px;
      padding: 0 8px;
      background: rgba(230, 239, 255, 1);
      color: #4e78f0;
      border: none;
    }

    & /deep/ .intelligence-popover + .intelligence-popover .el-tag {
      margin-left: 10px;
    }

    & /deep/ .input-new-tag {
      width: 90px;
      margin: 5px 10px 0 0;
      vertical-align: bottom;
    }
  }

  .right-label {
    flex: 1;
    margin-left: 20px;
    box-sizing: border-box;

    .behavior-tag {
      margin-top: -3px;

      .behavior-tag-item {
        cursor: pointer;
        height: 22px;
        box-sizing: border-box;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        margin: 15px 8px 0 0;

        .mk-tag {
          border-radius: 2px;
          padding: 0 8px;
          background: rgba(235, 239, 244, 1);
          color: #6b7b88;
          border: none;

          .exchange-icon {
            font-size: 12px;
            color: #788793;
            display: inline-block;
            transition: all 300ms ease-in;
            transform: rotate(0);
          }
        }
      }

      .behavior-tag-item.active {
        .mk-tag {
          background-color: #e6efff;
          color: #4e78f0;

          .exchange-icon {
            color: #4e78f0;
            transform: rotate(180deg);
          }
        }
      }

      .is-disabled {
        opacity: 1;
      }

      /deep/ .el-switch.is-disabled .el-switch__core,
      /deep/ .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
  }
}

.mk-tag {
  height: 22px;
  line-height: 22px;
}

.drawer-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  padding: 0 20px;
  box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
  border-top: 1px solid #e8e8e8;
}
</style>
